import { Group, Divider, Stack } from "@mantine/core";

const ModalFooter = ({ children }) => (
  <Stack
    gap={0}
    pos="sticky"
    bottom={0}
    styles={{
      root: {
        backgroundColor: "var(--mantine-color-body)",
        zIndex: 1000,
      },
    }}
  >
    <Divider mb="md" />
    <Group justify="flex-end">{children}</Group>
  </Stack>
);

export default ModalFooter;
